import { GetUsersWithLoginDataDocument } from '@/generated/graphql';
import { useQuery } from '@vue/apollo-composable';
import { computed } from 'vue';
import { mapUsers } from '../user';

export function useUserList() {
    // Loading the list is expensive, as the backend combines it with Entra data. So it is shared through the apollo
    // cache and only reloaded after user changes (see invalidateUserList) or a page reload.
    const { result, loading } = useQuery(GetUsersWithLoginDataDocument, null, { fetchPolicy: 'cache-first' });

    const users = computed(() => (result.value ? mapUsers(result.value) : undefined));
    const userCount = computed(() => users.value?.length);

    return {
        users,
        loading,
        userCount,
    };
}
